// extracted by mini-css-extract-plugin
export default {"input":"x2n8R","day":"B_1dY"};